import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import service1 from '../assets/images/service1.jpg';
import service2 from '../assets/images/service2.jpg';
import service3 from '../assets/images/service3.jpg';
import service4 from '../assets/images/service4.jpg';

const Services = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section id="services" className="py-5 bg-light">
      <div className="container">
        <h2 className="text-center mb-5">Our Services</h2>

        <div className="row g-4">
          {/* Service 1 */}
          <div className="col-md-6 col-lg-3" data-aos="fade-up">
            <div className="card h-100 border-0 shadow-sm">
              <img src={service1} className="card-img-top" alt="Metal Surface Coating" />
              <div className="card-body">
                <h5 className="card-title">Metal Surface Coating</h5>
                <p className="card-text">Durable powder coating for aluminum, steel, and iron components with long-lasting protection.</p>
              </div>
            </div>
          </div>

          {/* Service 2 */}
          <div className="col-md-6 col-lg-3" data-aos="zoom-in">
            <div className="card h-100 border-0 shadow-sm">
              <img src={service2} className="card-img-top" alt="Custom Color Finishing" />
              <div className="card-body">
                <h5 className="card-title">Custom Color Finishing</h5>
                <p className="card-text">We offer a wide variety of colors, textures, and finishes tailored to your project requirements.</p>
              </div>
            </div>
          </div>

          {/* Service 3 */}
          <div className="col-md-6 col-lg-3" data-aos="flip-left">
            <div className="card h-100 border-0 shadow-sm">
              <img src={service3} className="card-img-top" alt="Protective Coating" />
              <div className="card-body">
                <h5 className="card-title">Protective Coating</h5>
                <p className="card-text">Weather-resistant, corrosion-proof coatings for industrial and automotive applications.</p>
              </div>
            </div>
          </div>

          {/* Service 4 */}
          <div className="col-md-6 col-lg-3" data-aos="fade-down">
            <div className="card h-100 border-0 shadow-sm">
              <img src={service4} className="card-img-top" alt="Batch & Custom Jobs" />
              <div className="card-body">
                <h5 className="card-title">Batch & Custom Jobs</h5>
                <p className="card-text">From small-scale parts to large production batches — we handle all job sizes efficiently.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
